// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portalCms-column{padding:16px 20px 0}.portalCms-column-header{display:flex;justify-content:space-between;margin-bottom:16px}.portalCms-column-header .sw-button{font-size:14px;margin:0 8px 0 0}.portalCms-column-header .sw-button .sw-icon{font-size:16px;margin-right:3px}.portalCms-column-header .el-row{width:320px}", ""]);
// Exports
module.exports = exports;
